const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/user/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/user/homepage/index.js